import axios from 'axios'
import { Toast } from 'vant';
import { router } from '@/router';
import user from '@/utils/user'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if(user.getCacheUserData()) {
      // console.log("request==id===>" + user.getCacheUserData().id);
    }
    // console.log("request==token===>" + user.getCacheToken());
    config.headers['Authorization'] = user.getCacheToken()
    // config.headers['Authorization'] = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjY5ODA0MDgzNzc2MTc5ODE0NSIsImlzcyI6InhpbmppYW5nZ2FuZ3RvdSIsImF1ZCI6InhpbmppYW5nZ2FuZ3RvdTIifQ.SknqNUEznr77JYFbQ2QeXx0NBvcU3cKntTrGlzcIDCQ"
    return config
  },
  error => {
    // do something with request error
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // console.log(res);
    if (res.code === "A0230") {
      router.replace({ path: '/credit/login', query: { source: 'credit' } });
      Toast(res.message || 'Error');
      return Promise.reject(new Error(res.message || 'Error'))
    } else if (res.code != 0) {
      if(res.message == '权限不足') {
        router.replace({ path: '/credit/noPermission' });
      }
      Toast(res.message || 'Error');
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return response
    }
  },
  error => {
    // console.log(error.response);
    // console.log('err' + error) // for debug

    Toast(error.message);
    return Promise.reject(error)
  }
)

export default service
